import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { Button } from './ui/button';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'pt-BR' ? 'en-US' : 'pt-BR';
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  const currentLangDisplay = i18n.language === 'pt-BR' ? 'PT' : 'EN';

  return (
    <Button
      onClick={toggleLanguage}
      variant="ghost"
      size="sm"
      className="flex items-center gap-2 hover:bg-orange-50"
      title={i18n.language === 'pt-BR' ? 'Switch to English' : 'Mudar para Português'}
    >
      <Globe className="w-4 h-4" />
      <span className="text-sm font-medium">{currentLangDisplay}</span>
    </Button>
  );
};

export default LanguageSelector;
